import { Flex } from "antd"
import { useTranslation } from "react-i18next"
import { Card } from "../../components/Card"
import { LoginForm } from "../../components/LoginForm"
import { WEB_PORTALS } from "../../constants"

const { slovakCryptoNews, czechCryptoNews, slovakFtNews, czechFtNews } =
  WEB_PORTALS

export const Login: React.FC = () => {
  const { t } = useTranslation()
  return (
    <Flex wrap gap="small" justify="space-around" style={{ marginTop: 20 }}>
      <Card title={t("login.slovakCryptoNews")}>
        <LoginForm page={slovakCryptoNews} />
      </Card>
      <Card title={t("login.czechCryptoNews")}>
        <LoginForm page={czechCryptoNews} />
      </Card>
      <Card title={t("login.slovakFTNews")}>
        <LoginForm page={slovakFtNews} />
      </Card>
      <Card title={t("login.czechFTNews")}>
        <LoginForm page={czechFtNews} />
      </Card>
    </Flex>
  )
}
